import axios from 'axios';
import retryQuery from './RetryQuery';

const submitCareersForm = (careersBody) =>
  retryQuery(() =>
    axios.post(`${process.env.REACT_APP_API_URL}/careers`, careersBody ?? {})
  );

export default submitCareersForm;
